import {
  successContainer,
  successIcon as successIconStyle,
  successTitle as successTitleStyle,
  successMessage as successMessageStyle,
} from '@/shared/ui/templates/AuthScene/AuthScene.css';
import { SuccessCheckIcon } from '@/shared/ui/atoms';

export interface SuccessStepProps {
  /** e.g. "[접속 승인]" or "[등록 완료]" */
  title: string;
  /** Multi-line message. Supports React nodes for <br /> etc. */
  message: React.ReactNode;
}

/**
 * Shared success step screen for auth flows.
 * Displays a success icon, title, and message with reveal animation.
 */
export function SuccessStep({ title, message }: SuccessStepProps) {
  return (
    <div className={successContainer}>
      <SuccessCheckIcon className={successIconStyle} />
      <div className={successTitleStyle}>{title}</div>
      <p className={successMessageStyle}>{message}</p>
    </div>
  );
}
